import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { subscribeToUnauthorizedEvent } from "../../shared/authEvents";
import { useAuth } from "../../hooks/useAuth";

/**
 * Listener component that handles 401/403 Unauthorized events.
 *
 * This component is rendered inside the Router in App.js to listen for
 * "auth:unauthorized" events dispatched by the Axios interceptor.
 * When an event occurs, it triggers the logout flow and redirects to home.
 */
const AuthListener = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleUnauthorized = () => {
      logout();
      navigate("/", { replace: true });
    };

    const unsubscribe = subscribeToUnauthorizedEvent(handleUnauthorized);
    return unsubscribe;
  }, [logout, navigate]);

  return null; // This component renders nothing
};

export default AuthListener;
